import React from 'react';
import { FileTextIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
type TrustStripProps = {
  className?: string;
  /** 'short' is the 3-item strip under a CTA, 'full' adds the format. */
  variant?: 'short' | 'full';
};
const SHORT = [{
  Icon: ShieldCheckIcon,
  label: '7-day guarantee'
}, {
  Icon: LockIcon,
  label: 'Secure payment'
}, {
  Icon: ZapIcon,
  label: 'Instant access'
}];
const FULL = [{
  Icon: LockIcon,
  label: 'Secure payment'
}, {
  Icon: ZapIcon,
  label: 'Instant access'
}, {
  Icon: ShieldCheckIcon,
  label: '7-day guarantee'
}, {
  Icon: FileTextIcon,
  label: '100% PDF'
}];
export function TrustStrip({
  className = '',
  variant = 'short'
}: TrustStripProps) {
  const items = variant === 'full' ? FULL : SHORT;
  return <ul className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:text-[11px] ${className}`} data-id="element-335" data-mp="1wepobgb7ixdc">
      {items.map(({
      Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-336" data-mp="3msuqymvth20n">
          <Icon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-337" data-mp="3rro2i9rjmiy6" />
          {label}
        </li>)}
    </ul>;
}